import React from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'

import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import AppointmentCardLoading from '../../Components/AppointmentCardLoading/AppointmentCardLoading'
import AppointmentsList from '../../Components/AppointmentsList'
import BookAppointmentButton from '../../Components/BookAppointmentButton'

import styles from './Appointments.Styles'

function renderLoading() {
  return <AppointmentCardLoading
    containerStyle={styles.firstCardLoadingStyle}
  />
}

function renderAppointments(
  isLoading,
  appointments,
  formatAppointmentDate,
  withCancelBookingButton,
  onCancelBookingPress,
  withChangeBookingPress,
  onChangeBookingPress,
  getLocationData,
  services
) {
  if (isLoading) {
    return null
  }

  return (
    <AppointmentsList
      appointments={appointments}
      formatAppointmentDate={formatAppointmentDate}
      withCancelBookingButton={withCancelBookingButton}
      onCancelBookingPress={onCancelBookingPress}
      withChangeBookingPress={withChangeBookingPress}
      onChangeBookingPress={onChangeBookingPress}
      getLocationData={getLocationData}
      services={services}
    />
  )
}

const Appointments = ({
  appointments,
  isLoading,
  onBookAppointmentsButtonPress,
  formatAppointmentDate,
  withCancelBookingButton,
  onCancelBookingPress,
  withChangeBookingPress,
  onChangeBookingPress,
  getLocationData,
  services
}) => {

  const theme = useTheme()
  return (
    <View style={styles.container}>
      {isLoading && renderLoading()}
      {!isLoading && renderAppointments(
        isLoading,
        appointments,
        formatAppointmentDate,
        withCancelBookingButton,
        onCancelBookingPress,
        withChangeBookingPress,
        onChangeBookingPress,
        getLocationData,
        services
      )}
      {!isLoading && <View style={styles.buttonContainer(theme)}>
        <BookAppointmentButton
          isLoading={isLoading}
          onBookAppointmentsButtonPress={onBookAppointmentsButtonPress}
        />
      </View>}
    </View>
  )
}

Appointments.defaultProps = {
  withCancelBookingButton: true,
  withChangeBookingPress: true
}

Appointments.propTypes = {
  appointments: PropTypes.array,
  isLoading: PropTypes.bool,
  onBookAppointmentsButtonPress: PropTypes.func,
  formatAppointmentDate: PropTypes.func,
  withCancelBookingButton: PropTypes.bool,
  onCancelBookingPress: PropTypes.func,
  withChangeBookingPress: PropTypes.bool,
  onChangeBookingPress: PropTypes.func,
  getLocationData: PropTypes.func,
  services: PropTypes.array
}

export default Appointments
